export const applicationEndpoints = {
  subsidiaries: 'subsidiaries',
  contacts: 'contacts',
  subscriptions: 'subscriptions',
  reports: 'reports',
  reportsExport: 'reports/export',
  users: 'users',
  all: 'users/all',
  usersToImpersonate: 'users/to-impersonate',
  impersonateUser: 'oauth2/impersonate/:userId',
  retrieveTranslations: 'lokalise/retrieveTranslationFiles',
  roles: 'roles',
  getRoleByCode: 'roles/get-by-code',
};
